export enum AuthLocalStorageKeys {
  ExpireAt = 'expires_at',
  AccessToken = 'access_token',
  IdToken = 'id_token',
  Roles = 'roles'
}